const initialState = {};

const Reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "SAVE_DocumentList":
      return { ...state, List: payload };
    case "SAVE_TaskAttachments":
      return { ...state, TaskAttachments: payload };
    case "CLEAR":
      return initialState;
    default:
      return state;
  }
};

export default Reducer;
